// extracted by mini-css-extract-plugin
module.exports = {"staticMapContainer":"MobileStaticMap_staticMapContainer__G2ri1","staticMap":"MobileStaticMap_staticMap__2uGVU","button":"MobileStaticMap_button__mAZOj"};